// extracted by css-extract-rspack-plugin
export default {"container":"container-r3F5vi","name":"name-lki8AW"};